import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
const t = (key, params) => app.translator.trans('ppk2-profile.lib.support.' + key, params);
const FILTERS = ['open', 'resolved', ''];

/**
 * «Обращения»: requests from «Написать в техподдержку» in the registration form
 * (GET /api/ppk2/support-requests; admins and «Техподдержка»). Search, filter open / resolved,
 * «Решено» / «Открыть снова», the login that uses the nick now. attrs.oncount(n): open count.
 */
export default class SupportRequests extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.q = '';
    this.status = 'open';
    this.rows = null;
    this.error = false;
    this.busy = {};
    this.load();
  }
  count(n) {
    if (typeof n !== 'number') return;
    if (app.forum && app.forum.data && app.forum.data.attributes) app.forum.data.attributes.ppk2SupportOpen = n;
    if (this.attrs.oncount) this.attrs.oncount(n);
  }
  load() {
    this.rows = null;
    this.error = false;
    const params = {};
    if (this.q.trim()) params.q = this.q.trim();
    if (this.status) params.status = this.status;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/ppk2/support-requests',
      params
    }).then(r => {
      this.rows = r.data || [];
      this.count(r.openCount);
    }, () => this.error = true).finally(() => m.redraw());
  }
  setStatus(row, action) {
    this.busy[row.id] = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ppk2/support-requests/' + row.id + '/' + action
    }).then(r => {
      Object.assign(row, r.data);
      this.count(r.openCount);
    }, () => {}).finally(() => {
      delete this.busy[row.id];
      m.redraw();
    });
  }
  view() {
    const date = iso => iso ? dayjs(iso).format('YYYY-MM-DD HH:mm') : '';
    return m("div", {
      className: "Ppk2AccountLog Ppk2SupportList"
    }, m("div", {
      className: "Ppk2SupportList-bar"
    }, m("form", {
      className: "Ppk2AccountLog-search",
      onsubmit: e => {
        e.preventDefault();
        this.load();
      }
    }, m("input", {
      className: "FormControl",
      type: "search",
      placeholder: t('search'),
      value: this.q,
      oninput: e => this.q = e.target.value
    }), m(Button, {
      className: "Button",
      type: "submit",
      icon: "fas fa-search",
      "aria-label": t('search')
    })), m("div", {
      className: "ButtonGroup Ppk2SupportList-filter"
    }, FILTERS.map(f => m(Button, {
      className: 'Button' + (this.status === f ? ' Button--primary active' : ''),
      onclick: () => {
        this.status = f;
        this.load();
      }
    }, t(f ? 'f_' + f : 'f_all'))))), this.error ? m("p", {
      className: "helpText"
    }, "Error") : !this.rows ? m(LoadingIndicator, null) : !this.rows.length ? m("p", {
      className: "helpText"
    }, t('empty')) : m("div", {
      className: "Ppk2AccountLog-wrap"
    }, m("table", {
      className: "Ppk2AccountLog-table Ppk2SupportList-table"
    }, m("thead", null, m("tr", null, ['c_date', 'c_nick', 'c_owner', 'c_email', 'c_comment', 'c_ip', 'c_status', ''].map(k => m("th", null, k ? t(k) : '')))), m("tbody", null, this.rows.map(r => m("tr", {
      key: r.id,
      className: 'Ppk2SupportList-row--' + r.status
    }, m("td", null, date(r.createdAt)), m("td", null, m("b", null, r.nick), m("div", {
      className: "Ppk2AccountLog-note"
    }, t('type_' + r.type))), m("td", null, r.owner ? m("span", null, r.owner.username, m("div", {
      className: "Ppk2AccountLog-note"
    }, t(r.owner.kind === 'main' ? 'owner_main' : 'owner_twink'))) : m("span", {
      className: "Ppk2AccountLog-note"
    }, t('owner_none'))), m("td", null, m("a", {
      href: 'mailto:' + r.email
    }, r.email)), m("td", {
      className: "Ppk2SupportList-comment"
    }, r.comment || ''), m("td", null, r.ip || ''), m("td", null, m("span", {
      className: 'Ppk2SupportList-badge Ppk2SupportList-badge--' + r.status
    }, t('s_' + r.status)), r.status === 'resolved' && r.resolvedBy ? m("div", {
      className: "Ppk2AccountLog-note"
    }, t('resolved_by', {
      name: r.resolvedBy,
      date: date(r.resolvedAt)
    })) : null), m("td", null, r.status === 'open' ? m(Button, {
      className: "Button Button--primary Button--small",
      icon: "fas fa-check",
      loading: this.busy[r.id],
      onclick: () => this.setStatus(r, 'resolve')
    }, t('resolve')) : m(Button, {
      className: "Button Button--small",
      icon: "fas fa-rotate-left",
      loading: this.busy[r.id],
      onclick: () => this.setStatus(r, 'reopen')
    }, t('reopen'))))))), m("p", {
      className: "helpText Ppk2AccountLog-note"
    }, t('times_note'))));
  }
}
flarum.reg.add('ppk2-profile', 'common/SupportRequests', SupportRequests);